// extracted by mini-css-extract-plugin
export default {"warningBanner":"ViVnu8mnhd47Y3HD5wbv"};